import { DataGrid } from '@mui/x-data-grid';
import {
  Box,
  Button,
  Grid,
  Icon,
  IconButton,
  Paper,
  TextField,
  Tooltip,
} from '@mui/material';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ehrGetAllPatientRecords } from '../../../../pages/ehr/services';
import _, { isUndefined } from 'lodash';
import { components, getDateOnly } from '../../../../config/common';
import { useNavigate } from 'react-router-dom';

import { AgGridReact } from 'ag-grid-react';
// import toolBarContent from "./contents/toolbarContent";
//import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import AvatarRenderer from '../../../Renderers/avatarRederer';

import { auth } from '../../../../firebase';
import { ehrAPIBaseService } from '../../../../http-common';
import dayjs from 'dayjs';
import { useMainFrameState } from '../../../MainUIFrame/MainFrame';

import '../../../../themes/ag-grid/enliv-grid-theme.scss';
import { useSelector } from 'react-redux';

const columnData = [
  {
    field: 'avatar',
    headerName: 'Avatar',
    checkboxSelection: params => {
      return params?.data?.avatar !== 'not_found';
    },
    cellRenderer: AvatarRenderer,
    suppressMovable: true,
    suppressColumnsToolPanel: true,
    editable: false,
  },
  {
    field: 'patientName',
    headerName: 'Patient Name',
    flex: 1,
    editable: true,
    cellRenderer: 'loading',
    suppressMovable: true,
    suppressColumnsToolPanel: true,
    editable: false,
    // filter: "agTextColumnFilter",
    // checkboxSelection: true,
  },
  {
    field: 'gender',
    headerName: 'Gender',
    flex: 1,
    editable: true,
    suppressMovable: true,
    suppressColumnsToolPanel: true,
    editable: false,
    //  filter: "agTextColumnFilter"
  },
  {
    field: 'dob',
    headerName: 'DOB',
    flex: 1,
    editable: true,
    suppressMovable: true,
    suppressColumnsToolPanel: true,
    editable: false,
    // filter: "agTextColumnFilter"
  },
  {
    field: 'lastUpdated',
    headerName: 'Last Updated',
    flex: 1,
    suppressMovable: true,
    suppressColumnsToolPanel: true,
    editable: false,
  },
];

const SearchPatient = props => {
  const wordSearch = props?.wordSearch;
  const setIsSearch = props?.setIsSearch;
  useEffect(() => {
    if (wordSearch === '') {
      setIsTableVisible(false);
    } else {
      setIsTableVisible(true);
      onGridReady(gridApi);
    }
  }, [props?.wordSearch]);
  const selectedPatient = useSelector(
    state => state?.current?.currentClaimsObject?.patientObject
  );
  // const setShowCal = props?.setShowCal;
  const setPatientObject = props?.setPatientObject;
  const gridRef = useRef();
  // const containerStyle = useMemo(() => ({ width: '100%', height: '55vh' }), []);
  const gridStyle = useMemo(() => ({ width: '100%' }), []);

  const [gridApi, setGridApi] = useState(null);
  const [isTableVisible, setIsTableVisible] = useState(false);

  const { isDark } = useMainFrameState();

  const [rowData, setRowData] = useState([]);
  const [currentSelectedRow, setCurrentSelectedRow] = useState({});
  const [columnDefs, setColumnDefs] = useState(columnData);
  const [totalRecords, setTotalRecords] = useState(0);
  const [responseLink, setResponseLink] = useState([]);
  const [pageToken, setPageToken] = useState('');
  const [jwtToken, setJwtToken] = useState('');
  let tokenVar = '';

  let [realTotalPage, setRealTotalPage] = useState(0);

  let openPageToken = '';

  const navigate = useNavigate();
  const dataSource = {
    async getRows(params) {
      // debugger

      // console.log('i am datasource')
      console.log(JSON.stringify(params, null, 1));
      const { startRow, endRow, filterModel, sortModel } = params;
      let url = `fhir/search/?`;
      let _resourseType = `resourceType=Patient`;
      let _pageToken = `_page_token=${openPageToken}`;
      let _offset = `_offset=${parseInt(startRow + 1)}`;
      let _count = `_count=${parseInt(endRow - startRow)}`;
      let _sort = `_sort=-lastUpdated`;

      //Sorting
      if (sortModel.length) {
        const { colId, sort } = sortModel[0];
        if (colId === 'patientName') {
          if (sort === 'asc') {
            _sort += `,family`;
          } else {
            _sort += `,-family`;
          }
          // openPageToken = '';
        }

        if (colId === 'gender') {
          if (sort === 'asc') {
            _sort += `,gender`;
          } else {
            _sort += `,-gender`;
          }
          // openPageToken = '';
        }

        if (colId === 'lastUpdated') {
          if (sort === 'asc') {
            _sort = '_sort=lastUpdated';
          } else {
            _sort = '_sort=-lastUpdated';
          }
        }

        // if (colId === 'dob') {
        //   if (sort === 'asc') {
        //     _sort += `,birthDate`
        //   } else {
        //     _sort += `,-birthDate`
        //   }
        // }
      }
      // Filtering

      //Pagination
      url += `${_resourseType}&${_offset}&${_count}&${_sort}`;

      url += `&name:contains=${wordSearch}`;
      // openPageToken = '';
      debugger;
      if (!_.isEmpty(openPageToken) && endRow > 10) {
        url += `&${_pageToken}`;
      }

      // debugger

      let tempRows = [];
      ehrAPIBaseService
        .get(url)
        .then(responseData => {
          let response = responseData.data;
          // params.successCallback(response, 499);
          for (const item of response?.entry) {
            let singleRow = {};
            // singleRow.id = _.get(item, "resource.id", "");
            singleRow.avatar = {
              id: _.get(item, 'resource.id', ''),
              name: _.get(item, 'resource.name[0].family', ''),
            };

            //TODO: Until we fix text field properly
            singleRow.patientName = _.get(item, 'resource.name[0].text', '');
            singleRow.patientName = _.get(
              item,
              'resource.name[0].given[0]',
              ''
            );
            singleRow.patientName +=
              ' ' + _.get(item, 'resource.name[0].family', '');

            singleRow.gender = _.get(item, 'resource.gender', '');
            singleRow.dob = getDateOnly(_.get(item, 'resource.birthDate', ''));
            singleRow.resource = _.get(item, 'resource');
            // singleRow.lastUpdated =dayjs( _.get(item, "resource.meta.lastUpdated", "")).format("ddd, MMM D, YYYY h:mm A");
            singleRow.lastUpdated = getDateOnly(
              _.get(item, 'resource.meta.lastUpdated', '')
            );

            const city = _.get(item, 'resource.address[0].city', '');
            const state = _.get(item, 'resource.address[0].state', '');
            const postalCode = _.get(
              item,
              'resource.address[0].postalCode',
              ''
            );
            const line = _.get(item, 'resource.address[0].line[0]', '');

            singleRow.address = `${line}, ${city}, ${state}, ${postalCode}`;

            // singleRow.phone = item.resource.telecom?.[0].value;

            tempRows.push(singleRow);
          }
          // debugger
          // setResponseLink(response?.link)
          // setTotalRecords(response?.total)
          for (let obj of response?.link) {
            if (obj?.relation === 'next') {
              let tempPageToken = obj?.url?.split('_page_token=')?.[1];
              // setPageToken(tempPageToken)
              openPageToken = tempPageToken;
            }
          }

          if (startRow === 0) {
            realTotalPage = response?.total;
          }

          params.successCallback(tempRows, realTotalPage);
        })
        .catch(error => {
          console.error(error);
          params.successCallback([{ avatar: 'not_found' }], 1);
          // params.failCallback();
        });
    },
  };
  const schedule = () => {
    // setShowCal(true);
    props?.setIsSearch(false);
    props?.setIsCreateAppointment(true);
  };
  const onGridReady = params => {
    if (params == null) {
    } else {
      setGridApi(params);
      params.api.setDatasource(dataSource);
    }
  };
  const handleOnClick = () => {
    console.log('Handle on click called');
    setIsSearch(false);
  };

  const defaultColDef = useMemo(() => {
    return {
      // filter: true,
      floatingFilter: true,
      minWidth: 70,
      sortable: true,
    };
  }, []);

  return (
    <>
      <Grid container>
        <Grid
          container
          sx={{
            padding: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            item
            xs={6}
          ></Grid>
        </Grid>
        <Grid item xs={12}>
          {(wordSearch.length > 0 || localStorage.getItem('pateintID')) &&
            isTableVisible && (
              <div
                style={gridStyle}
                className={isDark ? `ag-theme-custom` : `ag-theme-alpine`}
              >
                <AgGridReact
                  domLayout="autoHeight"
                  ref={gridRef}
                  columnDefs={columnData}
                  defaultColDef={defaultColDef}
                  rowMultiSelectWithClick={false}
                  rowSelection={'single'}
                  paginationPageSize={10}
                  rowModelType="infinite"
                  components={components}
                  cacheBlockSize={10}
                  cacheOverflowSize={2}
                  maxConcurrentDatasourceRequests={2}
                  infiniteInitialRowCount={1}
                  maxBlocksInCache={2}
                  pagination={true}
                  animateRows={true}
                  onSelectionChanged={param => {
                    const selectedRowData =
                      gridRef?.current?.api?.getSelectedRows();
                    let sRow =
                      selectedRowData.length > 0 &&
                      selectedRowData[selectedRowData.length - 1];
                    console.log(sRow);
                    localStorage.setItem('pateintID', sRow?.resource?.id);
                    if (!isUndefined(props?.onPatientSelectCallback)) {
                      props?.onPatientSelectCallback(sRow.resource);
                    }
                  }}
                  onRowClicked={event => {
                    const clickedRowData = event?.data;
                    if (selectedPatient === clickedRowData?.resource) {
                      gridRef?.current?.api?.deselectAll();
                      localStorage.setItem('pateintID', '');
                      if (!isUndefined(props?.onPatientSelectCallback)) {
                        props?.onPatientSelectCallback({});
                      }
                    } else if (
                      props?.selectedPatientNew &&
                      clickedRowData?.resource === props?.selectedPatientNew[0]
                    ) {
                      gridRef?.current?.api?.deselectAll();
                      localStorage.setItem('pateintID', '');
                      if (!isUndefined(props?.onPatientSelectCallback)) {
                        props?.onPatientSelectCallback({});
                      }
                    }
                  }}
                  onGridReady={onGridReady}
                ></AgGridReact>
              </div>
            )}
        </Grid>
        <Grid item xs={12}>
          <br />
        </Grid>
        <Grid
          sx={{
            display: 'flex',
            gap: 2,
          }}
          item
          xs={12}
        >
          {/* <Button variant="outlined" onClick={schedule}>
            Schedule
          </Button> */}
          {!props.hasOwnProperty('hideCancel') && (
            <Button
              variant="outlined"
              onClick={handleOnClick}
              name="openRecord"
            >
              Cancel
            </Button>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default SearchPatient;
